import lodash from 'lodash'
import myCrypto from '../../libs/MyCrypto.lib'
import myTools from '../../libs/MyTools.lib'
import router from '../../../router/router'

let mydecptd = null
try {
  if (sessionStorage.getItem('cptd')) {
    const cptd = sessionStorage.getItem('cptd')
    if (!cptd) throw 'Empty cptd.'
    const decryptstr = myCrypto.Decrypto(cptd)
    if (!decryptstr) throw 'Failed to decrypto cptd.'
    mydecptd = myTools.convert2JOSN(decryptstr)
  }
} catch (err) {
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV === 'development') console.log(err)
}

const myErrors = {
  '0x009': {
    text: '該帳號等待審核中',
    icon: 'mdi-alert',
    color: 'warning'
  },
  //
  '1x000': {
    text: '帳號或密碼錯誤',
    icon: 'mdi-alert',
    color: 'error'
  },
  '1x011': {
    text: '連線過程出現異常,請聯絡管理員',
    icon: 'mdi-close-circle',
    color: 'warning'
  },
  '1x012': {
    text: '該帳號已被申請',
    icon: 'mdi-alert',
    color: 'warning'
  }
}

const ostate = {
  // Backend
  status: {
    loggedIn: false,
    logging: false,
    loginFaile: false,
    err: null
  },
  status2: {
    loggedIn: false,
    logging: false,
    loginFaile: false,
    //
    registerSuccess: false,
    registerFaile: false,
    //
    err: null
  },
  uid: null,
  user: null,
  user_id: null,
  level: 9,
  tag: null,
  ad_id: null,
  ag_id: null,
  g_id: null,
  entrace: null,
  loginAPI: null,
  homePage: null,
  //
  isSendRegister: false,
  //
  nothing: undefined
}

const state = mydecptd || lodash.cloneDeep(ostate)

const getters = {}

const mutations = {
  setLoginEntrace(state) {
    switch (window.location.pathname) {
      case '/adminLogin':
        state.homePage = '/system'
        state.loginAPI = 'adminLogin.php'
        state.entrace = '/adminLogin'
        state.tag = 1
        break

      case '/agentLogin':
        state.homePage = '/group'
        state.loginAPI = 'agentLogin.php'
        state.entrace = '/agentLogin'
        state.tag = 2
        break

      case '/memberp1':
      case '/memberp2':
      case '/memberp3':
        state.homePage = null
        state.loginAPI = null
        state.entrace = null
        state.tag = null
        break
    }
    // #region old
    // const loginLocations = [
    //   {
    //     tag: 1,
    //     route: '/system',
    //     location: '/adminLogin',
    //     api: 'adminLogin.php'
    //   },
    //   {
    //     tag: 2,
    //     route: '/group',
    //     location: '/agentLogin',
    //     api: 'agentLogin.php'
    //   },
    //   {
    //     tag: 2,
    //     route: '',
    //     location: '/agentp1',
    //     api: '',
    //     request: 'agentlogin'
    //   },
    //   {
    //     tag: 3,
    //     route: '',
    //     location: '/memberp1',
    //     api: '',
    //     request: 'memberlogin'
    //   }
    // ]
    // for (let i = 0; i < loginLocations.length; i++) {
    //   if (window.location.pathname === loginLocations[i].location) {
    //     state.homePage = loginLocations[i].route
    //     state.loginAPI = loginLocations[i].api
    //     state.entrace = loginLocations[i].location
    //     state.tag = loginLocations[i].tag
    //     state.request = loginLocations[i].request
    //     break
    //   }
    // }
    // #endregion
  },
  // Backend
  loginRequest(state, user) {
    state.status.logging = true
    state.user = user
  },
  loginFailure(state, d) {
    state.user = null
    state.status.logging = false
    state.status.loginFaile = true
    state.status.err = d ? d.err || null : null
  },
  loginSuccess(state, d) {
    state.status.logging = false
    state.status.loggedIn = true
    Object.assign(state, d)
    const cryptState = myCrypto.Crypto(JSON.stringify(state))
    sessionStorage.setItem('cptd', cryptState)
  },
  // #region Forward
  loginRequest2(state, user) {
    state.status2.logging = true
    state.user = user
  },
  loginFailure2(state) {
    state.user = null
    state.status2.logging = false
    state.status2.loginFaile = true
  },
  loginSuccess2(state, d) {
    state.status2.logging = false
    state.status2.loggedIn = true
    Object.assign(state, d)
    const cryptState = myCrypto.Crypto(JSON.stringify(state))
    sessionStorage.setItem('cptd', cryptState)
  },
  registerRequest2(state) {
    state.status2.err = null
    state.status2.registerFaile = false
    state.status2.registerSuccess = false
    state.isSendRegister = true
  },
  registerFailure2(state, d) {
    state.status2.err = d ? d.err || null : null
    state.status2.registerFaile = true
    state.isSendRegister = false
  },
  registerSuccess(state) {
    state.status2.registerSuccess = true
    state.isSendRegister = false
  },
  clearRegister(state) {
    state.status2.registerFaile = false
    state.status2.registerSuccess = false
    state.status2.err = null
  },
  // #endregion
  //
  logout(state) {
    sessionStorage.removeItem('cptd')
    const os = lodash.cloneDeep(ostate)
    const keys = Object.keys(state)
    keys.forEach(key => {
      if (os[key] !== undefined) state[key] = os[key]
    })
  }
}

const actions = {
  // Backend
  login({ rootState, state, commit, dispatch }, { user, pass }) {
    commit('setLoginEntrace')
    const path = state.loginAPI
    const url = rootState.apiPath + path

    commit('loginRequest', user)
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'user', value: user },
          { key: 'pass', value: pass }
        ],
        url: url
      },
      { root: true }
    ).then(res => {
      if (res.status !== 200 || !res.data) {
        commit('loginFailure')
        return
      }

      if (res.data.err) {
        // eslint-disable-next-line prettier/prettier
        res.data.err = myErrors[res.data.err] || { text: res.data.err, icon: '' }
        commit('loginFailure', res.data)
        return
      }

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) {
        commit('loginFailure')
        return
      }

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata || !decryptdata.uid) {
        commit('loginFailure')
        return
      }

      commit('loginSuccess', decryptdata)

      if (state.homePage) setTimeout(() => router.push(state.homePage), 250)
      // if (state.entrace === '/adminLogin') {
      //   setTimeout(() => router.push('/system'), 250)
      // } else {
      //   setTimeout(() => router.push('/group'), 250)
      // }
    })
    // #region not using
    // return new Promise(resolve => {
    //   dispatch(
    //     'sendRequest',
    //     {
    //       params: [
    //         { key: 'user', value: user },
    //         { key: 'pass', value: pass }
    //       ]
    //     },
    //     { root: true }
    //   )
    //     .then(res => {
    //       if (res.status !== 200 || !res.data) {
    //         commit('loginFailure')
    //         return
    //       }

    //       const decryptstr = myCrypto.Decrypto(res.data)
    //       if (!decryptstr) {
    //         commit('loginFailure')
    //         return
    //       }

    //       const decryptdata = myTools.convert2JOSN(decryptstr)
    //       if (!decryptdata || !decryptdata.uid) {
    //         commit('loginFailure')
    //         return
    //       }
    //       commit('loginSuccess', decryptdata)
    //       setTimeout(() => router.push('/dashboard'), 250)
    //     })
    //     .then(() => {
    //       resolve()
    //     })
    // })
    // #endregion
  },
  logout({ state, commit }) {
    const path = state.entrace
    commit('logout')
    router.push(path)
  },

  // Forward
  login2({ rootState, commit, dispatch }, { user, pass }) {
    const url = rootState.apiPath

    commit('loginRequest2', user)
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'request', value: 'login' },
          { key: 'user', value: user },
          { key: 'pass', value: pass }
        ],
        url: url
      },
      { root: true }
    ).then(res => {
      if (res.status !== 200 || !res.data) {
        commit('loginFailure2')
        return
      }

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) {
        commit('loginFailure2')
        return
      }

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata || !decryptdata.uid) {
        commit('loginFailure2')
        return
      }

      commit('loginSuccess2', decryptdata)
    })
  },
  logout2({ commit }) {
    commit('logout')
  },
  register2({ rootState, commit, dispatch }, { info }) {
    const url = rootState.apiPath

    commit('registerRequest2')
    return dispatch(
      'sendRequestWithOtherUrlENC',
      {
        params: [
          { key: 'request', value: 'register' },
          { key: 'info', value: info }
        ],
        url: url
      },
      { root: true }
    ).then(res => {
      if (res.status !== 200 || !res.data) {
        commit('registerFailure2')
        return
      }

      if (res.data.err) {
        // eslint-disable-next-line prettier/prettier
        res.data.err = myErrors[res.data.err] || { text: res.data.err, icon: '' }
        commit('registerFailure2', res.data)
        return
      }

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) {
        commit('registerFailure2')
        return
      }

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata || !decryptdata.res) {
        commit('registerFailure2')
        return
      }

      if (decryptdata.res) commit('registerSuccess', decryptdata)
    })
  },

  // Test
  test({ commit }) {
    commit('loginRequest', 'test01')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
